<template>
  <b-overlay :show="_status" rounded="sm">
    <b-card>
      <b-form @submit.prevent>
        <b-card-body>
          <b-row>
            <b-col md="10">
              <b-row>
                <b-col cols="2">
                  <b-form-input type="text" placeholder="Trendyol Barkod" v-model="_search.merchant_sku"/>
                </b-col>
                <b-col cols="2">
                  <b-form-input type="text" placeholder="İsim" v-model="_search.product_name"/>
                </b-col>
                <b-col cols="2">
                  <v-select
                      v-model="_search.brand_ids"
                      :options="brands"
                      label="name"
                      :reduce="item => item.ty_id"
                      input-id="brand"
                      multiple
                      placeholder="Markalar"
                      :filterable="true"
                      @search="getBrands"
                  />
                </b-col>
              </b-row>
            </b-col>
            <b-col md="2">
              <b-button-group>
                <b-button variant="primary" type="submit" @click="getAll">Getir</b-button>
                <b-button variant="danger" type="reset" @click="clearSearch">Temizle</b-button>
              </b-button-group>
            </b-col>
          </b-row>
        </b-card-body>
      </b-form>
    </b-card>
  </b-overlay>
</template>
<script>
import {mapGetters} from "vuex";
import vSelect from "vue-select";

export default {
  name: 'TrendyolProductSearch',
  components: {vSelect},
  data: () => ({
    brandSearchTimeout: null,
  }),
  computed: {
    ...mapGetters('tyProductV2', ['_status', '_products', '_search', '_pagination']),
    ...mapGetters('tyBrands', ['_brands']),
    brands() {
      return this._brands.slice(0, 100)
    }
  },
  methods: {
    getAll() {
      this.$store.dispatch('tyProductV2/getProducts')
    },
    clearSearch() {
      this.$store.commit('tyProductV2/clearSearch')
    },
    getBrands(searchText) {
      if (!searchText || searchText.length < 3) {
        return;
      }

      if (this.brandSearchTimeout) {
        clearTimeout(this.brandSearchTimeout);
      }
      this.brandSearchTimeout = setTimeout(() => {
        this.$store.state.tyBrands.search.name = searchText;
        this.$store.dispatch('tyBrands/getAll');
      }, 1000);
    }
  }
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>